import { Flex } from 'foundations-components/components/Flex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SummaryHeaderUploadSpinner() {
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    alignItems: "center",
    inlineSize: "140px",
    blockSize: "140px",
    children: /*#__PURE__*/_jsx(LoadingSpinner, {})
  });
}